import * as type from '../actions/types';

const initialState = {
  data: [],
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.POST_ALL_DAILY_OPPOS_PENDING:
      return {
        ...state,
        pending: true,
        error: '',
      };
    case type.POST_ALL_DAILY_OPPOS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        pending: false,
        success: true,
      };
    case type.POST_ALL_DAILY_OPPOS_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    case type.CLEAR_POST_ALL_DAILY_OPPOS:
      return {
        ...state,
        data: [],
        pending: false,
        error: '',
        success: false,
      };

    default:
      return state;
  }
};
